/** Root для inline subscribe — монтируется в #shop-subscribe-inline при mode=inline */
import { useState, useEffect } from 'preact/hooks';
import { store } from '../store';
import { getLocale } from '../i18n';
import { getConfig } from '../config';
import { SubscribeInlineForm } from './SubscribeInlineForm';
import { isTargetingMatch } from '../subscribeTargeting';
import { canShow } from '../subscribeGuards';

export function SubscribeInlineRoot() {
  const [settings, setSettings] = useState(store.getSettings());

  useEffect(() => {
    return store.subscribe(() => setSettings(store.getSettings()));
  }, []);

  const sub = settings?.subscribe;
  if (!sub?.enabled || sub.mode !== 'inline') return null;

  const ctx = {
    pathname: typeof window !== 'undefined' ? window.location.pathname || '/' : '/',
    isDesktop: typeof window !== 'undefined' && window.innerWidth >= 768,
    locale: getLocale(),
    utmSource: typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('utm_source') : null,
  };
  if (!isTargetingMatch(sub.targeting, ctx)) return null;

  const config = getConfig();
  const siteKey = config.siteKey;
  if (!siteKey || !canShow(siteKey, { frequency_cap: sub.frequency_cap, cooldown_after_close_hours: sub.cooldown_after_close_hours, stop_after_submit: sub.stop_after_submit !== false })) {
    return null;
  }

  return <SubscribeInlineForm settings={settings} />;
}
